/**
 * Bikeman Vehicle Search — フロントエンドJS
 *
 * テキストサジェスト + 4段階カスケードドロップダウン + Webike風階層カテゴリ + 商品グリッド + ページネーション
 */
(function () {
  'use strict';

  var CFG = window.__VS_CONFIG__ || {};
  var API = CFG.apiBase || '';
  var PER_PAGE = CFG.perPage || 40;
  var MY_BIKE_ACCOUNT_URL = CFG.myBikeAccountUrl
    || 'https://account.bikeman.jp/pages/019f6d9c-468d-7542-a0e5-b251669b9ad8';

  // --- DOM ---
  var els = {
    textInput:    document.getElementById('vs-text-input'),
    textBtn:      document.getElementById('vs-text-search-btn'),
    suggest:      document.getElementById('vs-suggest'),
    mfr:          document.getElementById('vs-mfr'),
    displacement: document.getElementById('vs-displacement'),
    model:        document.getElementById('vs-model'),
    year:         document.getElementById('vs-year'),
    myBikeSelect: document.getElementById('vs-my-bike-select'),
    dropdownBtn:  document.getElementById('vs-dropdown-search-btn'),
    keywordInput: document.getElementById('vs-keyword-input'),
    keywordBtn:   document.getElementById('vs-keyword-search-btn'),
    keywordClear: document.getElementById('vs-keyword-clear-btn'),
    collections:  document.getElementById('vs-collections'),
    results:      document.getElementById('vs-results'),
    summary:      document.getElementById('vs-results-summary'),
    myBikeRegister: document.getElementById('vs-my-bike-register'),
    myBikeRegisterBtn: document.getElementById('vs-my-bike-register-btn'),
    myBikeRegisterMessage: document.getElementById('vs-my-bike-register-message'),
    grid:         document.getElementById('vs-results-grid'),
    pagination:   document.getElementById('vs-pagination'),
    loading:      document.getElementById('vs-loading'),
    empty:        document.getElementById('vs-empty'),
  };

  // --- State ---
  var suggestTimer = null;
  var currentPage = 1;
  var lastSearchParams = {};
  var lastVehicleGid = '';

  // =========================================
  // ユーティリティ
  // =========================================
  function show(el) { el && (el.hidden = false); }
  function hide(el) { el && (el.hidden = true); }

  function resetSelect(el, placeholder) {
    el.innerHTML = '<option value="">' + placeholder + '</option>';
    el.disabled = true;
  }

  function populateSelect(el, items, placeholder) {
    el.innerHTML = '<option value="">' + placeholder + '</option>';
    items.forEach(function (item) {
      var opt = document.createElement('option');
      opt.value = item.name;
      opt.textContent = item.name + '（' + item.product_count + '件）';
      if (item.vehicle_gid) opt.dataset.vehicleGid = item.vehicle_gid;
      el.appendChild(opt);
    });
    el.disabled = items.length === 0;
  }

  function formatPrice(price) {
    if (price == null || price === '') return '';
    var n = parseFloat(price);
    if (isNaN(n)) return '';
    return '¥' + Math.floor(n).toLocaleString('ja-JP');
  }

  // =========================================
  // API 通信
  // =========================================
  function fetchJSON(url) {
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
  }

  function suggestURL(q) {
    return API + '/api/vehicle_suggest.php?q=' + encodeURIComponent(q);
  }

  function cascadeURL(type, params) {
    var qs = 'type=' + type;
    if (params.manufacturer)  qs += '&manufacturer='  + encodeURIComponent(params.manufacturer);
    if (params.displacement)  qs += '&displacement='  + encodeURIComponent(params.displacement);
    if (params.model_name)    qs += '&model_name='    + encodeURIComponent(params.model_name);
    return API + '/api/vehicle_suggest.php?' + qs;
  }

  function searchURL(params, page) {
    var qs = [];
    if (params.q)            qs.push('q='            + encodeURIComponent(params.q));
    if (params.manufacturer) qs.push('manufacturer='  + encodeURIComponent(params.manufacturer));
    if (params.displacement) qs.push('displacement='  + encodeURIComponent(params.displacement));
    if (params.year)         qs.push('year='          + encodeURIComponent(params.year));
    if (params.keyword)      qs.push('keyword='       + encodeURIComponent(params.keyword));
    if (params.category)     qs.push('category='      + encodeURIComponent(params.category));
    qs.push('page=' + page);
    qs.push('per_page=' + PER_PAGE);
    return API + '/api/vehicle_search.php?' + qs.join('&');
  }

  // =========================================
  // テキストサジェスト
  // =========================================
  function onTextInput() {
    clearTimeout(suggestTimer);
    var q = els.textInput.value.trim();
    if (q.length < 1) {
      hide(els.suggest);
      return;
    }
    suggestTimer = setTimeout(function () {
      fetchJSON(suggestURL(q))
        .then(function (res) { renderSuggest(res.data || []); })
        .catch(function () { hide(els.suggest); });
    }, 300);
  }

  function renderSuggest(items) {
    if (items.length === 0) {
      hide(els.suggest);
      return;
    }
    var html = '';
    items.forEach(function (item) {
      html += '<div class="vs-suggest__item" data-model="' + escapeAttr(item.model_name) + '"'
            + ' data-mfr="' + escapeAttr(item.manufacturer) + '"'
            + ' data-vehicle-gid="' + escapeAttr(item.vehicle_gid || '') + '">'
            + '<span class="vs-suggest__name">' + escapeHTML(item.model_name) + '</span>'
            + '<span class="vs-suggest__meta">' + escapeHTML(item.manufacturer)
            + (item.displacement ? ' / ' + escapeHTML(item.displacement) : '')
            + ' (' + item.product_count + '件)</span>'
            + '</div>';
    });
    els.suggest.innerHTML = html;
    show(els.suggest);
  }

  function onSuggestClick(e) {
    var item = e.target.closest('.vs-suggest__item');
    if (!item) return;
    var model = item.dataset.model;
    lastVehicleGid = item.dataset.vehicleGid || '';
    els.textInput.value = model;
    hide(els.suggest);
    doSearch({ q: model }, 1);
  }

  function onTextSearch() {
    var q = els.textInput.value.trim();
    if (!q) return;
    lastVehicleGid = '';
    hide(els.suggest);
    doSearch({ q: q }, 1);
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function selectedOptionGid(select) {
    var option = select && select.options[select.selectedIndex];
    return option && option.dataset.vehicleGid ? option.dataset.vehicleGid : '';
  }

  function updateSelectedVehicleGid() {
    lastVehicleGid = selectedOptionGid(els.year) || selectedOptionGid(els.model) || lastVehicleGid || '';
  }

  // =========================================
  // 4段階カスケード
  // =========================================
  function loadManufacturers() {
    fetchJSON(cascadeURL('manufacturers', {}))
      .then(function (res) {
        populateSelect(els.mfr, res.data || [], 'メーカーを選択');
        els.mfr.disabled = false;
      });
  }

  function onMfrChange() {
    var mfr = els.mfr.value;
    resetSelect(els.displacement, '排気量を選択');
    resetSelect(els.model, '車種を選択');
    resetSelect(els.year, '年式を選択');
    lastVehicleGid = '';
    els.dropdownBtn.disabled = !mfr;

    if (!mfr) return;

    fetchJSON(cascadeURL('displacements', { manufacturer: mfr }))
      .then(function (res) {
        var data = res.data || [];
        if (data.length > 0) {
          populateSelect(els.displacement, data, '排気量を選択');
        } else {
          loadModels(mfr, '');
        }
      });
  }

  function onDisplacementChange() {
    var mfr = els.mfr.value;
    var disp = els.displacement.value;
    resetSelect(els.model, '車種を選択');
    resetSelect(els.year, '年式を選択');
    lastVehicleGid = '';
    els.dropdownBtn.disabled = !els.mfr.value;

    if (!mfr) return;
    loadModels(mfr, disp);
  }

  function loadModels(mfr, disp) {
    var params = { manufacturer: mfr };
    if (disp) params.displacement = disp;

    fetchJSON(cascadeURL('models', params))
      .then(function (res) {
        populateSelect(els.model, res.data || [], '車種を選択');
      });
  }

  function onModelChange() {
    var mfr   = els.mfr.value;
    var disp  = els.displacement.value;
    var model = els.model.value;
    resetSelect(els.year, '年式を選択');
    lastVehicleGid = selectedOptionGid(els.model);
    els.dropdownBtn.disabled = !els.mfr.value;

    if (!mfr || !model) return;

    var params = { manufacturer: mfr, model_name: model };
    if (disp) params.displacement = disp;

    fetchJSON(cascadeURL('years', params))
      .then(function (res) {
        populateSelect(els.year, res.data || [], '年式を選択');
        updateSelectedVehicleGid();
      });
  }

  function onYearChange() {
    updateSelectedVehicleGid();
    els.dropdownBtn.disabled = !els.mfr.value;
  }

  function onDropdownSearch() {
    var params = {};
    if (els.model.value) params.q = els.model.value;
    if (els.mfr.value)   params.manufacturer = els.mfr.value;
    if (els.displacement.value) params.displacement = els.displacement.value;
    if (els.year.value && els.year.value !== '全年式') params.year = els.year.value;
    updateSelectedVehicleGid();
    doSearch(params, 1);
  }

  function onMyBikeSelectChange() {
    var option = els.myBikeSelect && els.myBikeSelect.options[els.myBikeSelect.selectedIndex];
    if (!option || !option.value) return;
    lastVehicleGid = option.value;
    var params = {};
    if (option.dataset.model) params.q = option.dataset.model;
    if (option.dataset.manufacturer) params.manufacturer = option.dataset.manufacturer;
    if (option.dataset.year) params.year = option.dataset.year;
    els.textInput.value = option.dataset.model || '';
    doSearch(params, 1);
  }

  // =========================================
  // キーワード絞り込み
  // =========================================
  function onKeywordSearch() {
    var keyword = els.keywordInput.value.trim();
    var params = Object.assign({}, lastSearchParams);
    if (keyword) {
      params.keyword = keyword;
    } else {
      delete params.keyword;
    }
    doSearch(params, 1);
  }

  function onKeywordClear() {
    els.keywordInput.value = '';
    hide(els.keywordClear);
    var params = Object.assign({}, lastSearchParams);
    delete params.keyword;
    doSearch(params, 1);
  }

  // =========================================
  // アコーディオン状態の保存・復元
  // =========================================
  function saveAccordionState() {
    var state = { spL3: [], spL4: [], spL5: [], pcL4: [], pcL5: [] };
    if (els.collections.hidden) return state;
    var i, body, sub, subsub, li, btn;

    // SP L3: open accordion items
    var l3items = els.collections.querySelectorAll('.vs-cat__acc-item--open');
    for (i = 0; i < l3items.length; i++) {
      var l3link = l3items[i].querySelector('.vs-cat__acc-link[data-category]');
      if (l3link) state.spL3.push(l3link.dataset.category);
    }

    // SP L4: open sub-accordions
    var subBodies = els.collections.querySelectorAll('.vs-cat__acc-sub-body');
    for (i = 0; i < subBodies.length; i++) {
      body = subBodies[i];
      if (!body.hidden) {
        sub = body.closest('.vs-cat__acc-sub');
        var l4link = sub && sub.querySelector('.vs-cat__acc-child[data-category]');
        if (l4link) state.spL4.push(l4link.dataset.category);
      }
    }

    // SP L5: open sub-sub-accordions
    var subsubBodies = els.collections.querySelectorAll('.vs-cat__acc-subsub-body');
    for (i = 0; i < subsubBodies.length; i++) {
      body = subsubBodies[i];
      if (!body.hidden) {
        subsub = body.closest('.vs-cat__acc-subsub');
        var l5link = subsub && subsub.querySelector('.vs-cat__acc-grandchild[data-category]');
        if (l5link) state.spL5.push(l5link.dataset.category);
      }
    }

    // PC L4: open sublists
    var sublists = els.collections.querySelectorAll('.vs-cat__card-sublist');
    for (i = 0; i < sublists.length; i++) {
      if (!sublists[i].hidden) {
        li = sublists[i].parentElement;
        btn = li && li.querySelector('[data-pc-toggle]');
        if (btn) state.pcL4.push(btn.dataset.pcToggle);
      }
    }

    // PC L5: open sub-sublists
    var subsublists = els.collections.querySelectorAll('.vs-cat__card-subsublist');
    for (i = 0; i < subsublists.length; i++) {
      if (!subsublists[i].hidden) {
        li = subsublists[i].parentElement;
        btn = li && li.querySelector('[data-pc-l5-toggle]');
        if (btn) state.pcL5.push(btn.dataset.pcL5Toggle);
      }
    }

    return state;
  }

  function restoreAccordionState(state) {
    var i, link, item, body, toggle, sub, subsub, btn, li, sublist, subsublist;

    // SP L3
    for (i = 0; i < state.spL3.length; i++) {
      link = els.collections.querySelector('.vs-cat__acc-link[data-category="' + state.spL3[i] + '"]');
      if (!link) continue;
      item = link.closest('.vs-cat__acc-item');
      if (!item || item.classList.contains('vs-cat__acc-item--open')) continue;
      body = item.querySelector('.vs-cat__acc-body');
      if (!body) continue;
      body.hidden = false;
      item.classList.add('vs-cat__acc-item--open');
      toggle = item.querySelector('.vs-cat__acc-header .vs-cat__acc-toggle');
      if (toggle) toggle.textContent = '－';
    }

    // SP L4
    for (i = 0; i < state.spL4.length; i++) {
      link = els.collections.querySelector('.vs-cat__acc-sub .vs-cat__acc-child[data-category="' + state.spL4[i] + '"]');
      if (!link) continue;
      sub = link.closest('.vs-cat__acc-sub');
      if (!sub) continue;
      body = sub.querySelector('.vs-cat__acc-sub-body');
      if (!body || !body.hidden) continue;
      body.hidden = false;
      toggle = sub.querySelector('.vs-cat__acc-toggle');
      if (toggle) toggle.textContent = '－';
    }

    // SP L5
    for (i = 0; i < state.spL5.length; i++) {
      link = els.collections.querySelector('.vs-cat__acc-subsub .vs-cat__acc-grandchild[data-category="' + state.spL5[i] + '"]');
      if (!link) continue;
      subsub = link.closest('.vs-cat__acc-subsub');
      if (!subsub) continue;
      body = subsub.querySelector('.vs-cat__acc-subsub-body');
      if (!body || !body.hidden) continue;
      body.hidden = false;
      subsub.classList.add('vs-cat__acc-subsub--open');
      toggle = subsub.querySelector('.vs-cat__acc-toggle');
      if (toggle) toggle.textContent = '－';
    }

    // PC L4
    for (i = 0; i < state.pcL4.length; i++) {
      btn = els.collections.querySelector('[data-pc-toggle="' + state.pcL4[i] + '"]');
      if (!btn) continue;
      li = btn.closest('li');
      if (!li) continue;
      sublist = li.querySelector('.vs-cat__card-sublist');
      if (!sublist || !sublist.hidden) continue;
      sublist.hidden = false;
      btn.textContent = '－';
    }

    // PC L5
    for (i = 0; i < state.pcL5.length; i++) {
      btn = els.collections.querySelector('[data-pc-l5-toggle="' + state.pcL5[i] + '"]');
      if (!btn) continue;
      li = btn.closest('li');
      if (!li) continue;
      subsublist = li.querySelector('.vs-cat__card-subsublist');
      if (!subsublist || !subsublist.hidden) continue;
      subsublist.hidden = false;
      btn.textContent = '－';
    }
  }

  // =========================================
  // 階層カテゴリ表示（Webike風）
  // =========================================
  function renderCategories(categories, totalAll) {
    if (!categories || categories.length === 0) {
      hide(els.collections);
      return;
    }

    // L4子カテゴリがないL3は非表示（重複防止: 同名がL5等に存在するケース）
    categories = categories.filter(function (cat) {
      return cat.children && cat.children.length > 0;
    });

    if (categories.length === 0) {
      hide(els.collections);
      return;
    }

    var activeCategory = lastSearchParams.category || '';
    var isMobile = window.innerWidth < 768;

    var html = '<div class="vs-cat__header">'
             + '<h3 class="vs-cat__title">カテゴリで絞り込み</h3>'
             + '<button class="vs-cat__all-btn' + (!activeCategory ? ' vs-cat__all-btn--active' : '') + '" data-category="">'
             + 'すべて（' + totalAll + '件）</button>'
             + '</div>';

    if (isMobile) {
      // --- SP: アコーディオン（L3 > L4 > L5） ---
      html += '<div class="vs-cat__accordion">';
      categories.forEach(function (cat) {
        var isL3Active = activeCategory === String(cat.id);
        var hasActiveChild = false;
        if (cat.children && cat.children.length > 0) {
          cat.children.forEach(function (child) {
            if (activeCategory === String(child.id)) hasActiveChild = true;
            if (child.children && child.children.length > 0) {
              child.children.forEach(function (gc) {
                if (activeCategory === String(gc.id)) hasActiveChild = true;
                if (gc.children && gc.children.length > 0) {
                  gc.children.forEach(function (l6) {
                    if (activeCategory === String(l6.id)) hasActiveChild = true;
                  });
                }
              });
            }
          });
        }
        var isOpen = isL3Active || hasActiveChild;

        html += '<div class="vs-cat__acc-item' + (isOpen ? ' vs-cat__acc-item--open' : '') + '">';
        html += '<div class="vs-cat__acc-header">';
        html += '<a href="#" class="vs-cat__acc-link' + (isL3Active ? ' vs-cat__acc-link--active' : '') + '" data-category="' + cat.id + '">'
              + escapeHTML(cat.title) + '（' + cat.count + '）</a>';
        if (cat.children && cat.children.length > 0) {
          html += '<button class="vs-cat__acc-toggle" aria-label="展開" data-toggle="' + cat.id + '">'
                + (isOpen ? '－' : '＋') + '</button>';
        }
        html += '</div>';

        if (cat.children && cat.children.length > 0) {
          html += '<div class="vs-cat__acc-body"' + (isOpen ? '' : ' hidden') + '>';
          cat.children.forEach(function (child) {
            var isL4Active = activeCategory === String(child.id);
            var hasActiveGC = false;
            if (child.children && child.children.length > 0) {
              child.children.forEach(function (gc) {
                if (activeCategory === String(gc.id)) hasActiveGC = true;
                // L6 children check
                if (gc.children && gc.children.length > 0) {
                  gc.children.forEach(function (l6) {
                    if (activeCategory === String(l6.id)) hasActiveGC = true;
                  });
                }
              });
            }
            var isL4Open = isL4Active || hasActiveGC;

            if (child.children && child.children.length > 0) {
              // L4 with L5 children → sub-accordion
              html += '<div class="vs-cat__acc-sub">';
              html += '<div class="vs-cat__acc-sub-header">';
              html += '<a href="#" class="vs-cat__acc-child' + (isL4Active ? ' vs-cat__acc-child--active' : '') + '" data-category="' + child.id + '">'
                    + '› ' + escapeHTML(child.title) + '（' + child.count + '）</a>';
              html += '<button class="vs-cat__acc-toggle vs-cat__acc-toggle--sm" aria-label="展開" data-toggle="l4-' + child.id + '">'
                    + (isL4Open ? '－' : '＋') + '</button>';
              html += '</div>';
              html += '<div class="vs-cat__acc-sub-body"' + (isL4Open ? '' : ' hidden') + '>';
              child.children.forEach(function (gc) {
                var isGCActive = activeCategory === String(gc.id);
                var hasActiveL6 = gc.children && gc.children.length > 0 && gc.children.some(function (l6) {
                  return activeCategory === String(l6.id);
                });
                var isL5Open = isGCActive || hasActiveL6;
                if (gc.children && gc.children.length > 0) {
                  // L5 with L6 children → sub-sub accordion
                  html += '<div class="vs-cat__acc-subsub' + (isL5Open ? ' vs-cat__acc-subsub--open' : '') + '">';
                  html += '<div class="vs-cat__acc-subsub-header">';
                  html += '<a href="#" class="vs-cat__acc-grandchild' + (isGCActive ? ' vs-cat__acc-grandchild--active' : '') + '" data-category="' + gc.id + '">'
                        + '» ' + escapeHTML(gc.title) + '（' + gc.count + '）</a>';
                  html += '<button class="vs-cat__acc-toggle vs-cat__acc-toggle--xs" aria-label="展開" data-toggle="l5-' + gc.id + '">'
                        + (isL5Open ? '－' : '＋') + '</button>';
                  html += '</div>';
                  html += '<div class="vs-cat__acc-subsub-body"' + (isL5Open ? '' : ' hidden') + '>';
                  gc.children.forEach(function (l6) {
                    var isL6Active = activeCategory === String(l6.id);
                    html += '<a href="#" class="vs-cat__acc-greatgrandchild' + (isL6Active ? ' vs-cat__acc-greatgrandchild--active' : '') + '" data-category="' + l6.id + '">'
                          + '» ' + escapeHTML(l6.title) + '（' + l6.count + '）</a>';
                  });
                  html += '</div>';
                  html += '</div>';
                } else {
                  // L5 without L6
                  html += '<a href="#" class="vs-cat__acc-grandchild' + (isGCActive ? ' vs-cat__acc-grandchild--active' : '') + '" data-category="' + gc.id + '">'
                        + '» ' + escapeHTML(gc.title) + '（' + gc.count + '）</a>';
                }
              });
              html += '</div>';
              html += '</div>';
            } else {
              // L4 without L5 children
              html += '<a href="#" class="vs-cat__acc-child' + (isL4Active ? ' vs-cat__acc-child--active' : '') + '" data-category="' + child.id + '">'
                    + '› ' + escapeHTML(child.title) + '（' + child.count + '）</a>';
            }
          });
          html += '</div>';
        }

        html += '</div>';
      });
      html += '</div>';
    } else {
      // --- PC: 3カラムカードグリッド（L3 > L4 > L5） ---
      html += '<div class="vs-cat__grid">';
      categories.forEach(function (cat) {
        var isL3Active = activeCategory === String(cat.id);
        html += '<div class="vs-cat__card">';
        html += '<a href="#" class="vs-cat__card-header' + (isL3Active ? ' vs-cat__card-header--active' : '') + '" data-category="' + cat.id + '">'
              + escapeHTML(cat.title) + '<span class="vs-cat__card-count">（' + cat.count + '）</span></a>';

        if (cat.children && cat.children.length > 0) {
          html += '<ul class="vs-cat__card-list">';
          var maxShow = 5;
          for (var i = 0; i < cat.children.length; i++) {
            var child = cat.children[i];
            var isL4Active = activeCategory === String(child.id);
            var hasL5 = child.children && child.children.length > 0;
            // L5またはL6がアクティブな場合はsublistを展開
            var isL4SubOpen = isL4Active;
            if (hasL5) {
              child.children.forEach(function (gc) {
                if (activeCategory === String(gc.id)) isL4SubOpen = true;
                if (gc.children && gc.children.length > 0) {
                  gc.children.forEach(function (l6) {
                    if (activeCategory === String(l6.id)) isL4SubOpen = true;
                  });
                }
              });
            }
            // 6件目以降は非表示
            html += '<li' + (i >= maxShow ? ' hidden' : '') + '>';
            // L4行: リンク + L5トグルボタン
            html += '<div class="vs-cat__card-l4-row">';
            html += '<a href="#" class="vs-cat__card-link' + (isL4Active ? ' vs-cat__card-link--active' : '') + '" data-category="' + child.id + '">'
                  + '› ' + escapeHTML(child.title) + '（' + child.count + '）</a>';
            if (hasL5) {
              html += '<button class="vs-cat__card-l4-toggle" data-pc-toggle="' + child.id + '" aria-label="展開">' + (isL4SubOpen ? '－' : '＋') + '</button>';
            }
            html += '</div>';
            // L5 孫カテゴリ（アクティブ時は展開、それ以外はトグルで展開）
            if (hasL5) {
              html += '<ul class="vs-cat__card-sublist"' + (isL4SubOpen ? '' : ' hidden') + '>';
              child.children.forEach(function (gc) {
                var isGCActive = activeCategory === String(gc.id);
                var hasL6 = gc.children && gc.children.length > 0;
                var hasActiveL6 = hasL6 && gc.children.some(function (l6) {
                  return activeCategory === String(l6.id);
                });
                if (hasL6) {
                  // L5 with L6 children
                  html += '<li>';
                  html += '<div class="vs-cat__card-l5-row">';
                  html += '<a href="#" class="vs-cat__card-sublink' + (isGCActive ? ' vs-cat__card-sublink--active' : '') + '" data-category="' + gc.id + '">'
                        + '» ' + escapeHTML(gc.title) + '（' + gc.count + '）</a>';
                  html += '<button class="vs-cat__card-l5-toggle" data-pc-l5-toggle="' + gc.id + '" aria-label="展開">'
                        + (hasActiveL6 ? '－' : '＋') + '</button>';
                  html += '</div>';
                  html += '<ul class="vs-cat__card-subsublist"' + (hasActiveL6 ? '' : ' hidden') + '>';
                  gc.children.forEach(function (l6) {
                    var isL6Active = activeCategory === String(l6.id);
                    html += '<li><a href="#" class="vs-cat__card-subsublink' + (isL6Active ? ' vs-cat__card-subsublink--active' : '') + '" data-category="' + l6.id + '">'
                          + '» ' + escapeHTML(l6.title) + '（' + l6.count + '）</a></li>';
                  });
                  html += '</ul>';
                  html += '</li>';
                } else {
                  // L5 without L6
                  html += '<li><a href="#" class="vs-cat__card-sublink' + (isGCActive ? ' vs-cat__card-sublink--active' : '') + '" data-category="' + gc.id + '">'
                        + '» ' + escapeHTML(gc.title) + '（' + gc.count + '）</a></li>';
                }
              });
              html += '</ul>';
            }
            html += '</li>';
          }
          html += '</ul>';
          if (cat.children.length > maxShow) {
            html += '<a href="#" class="vs-cat__card-more">もっと見る</a>';
          }
        }

        html += '</div>';
      });
      html += '</div>';
    }

    var prevState = saveAccordionState();
    els.collections.innerHTML = html;
    show(els.collections);
    restoreAccordionState(prevState);
  }

  function onCategoryClick(e) {
    // --- PC: 「もっと見る」ボタン ---
    var moreBtn = e.target.closest('.vs-cat__card-more');
    if (moreBtn) {
      e.preventDefault();
      var card = moreBtn.closest('.vs-cat__card');
      if (card) {
        var hiddenItems = card.querySelectorAll('.vs-cat__card-list > li[hidden]');
        for (var i = 0; i < hiddenItems.length; i++) {
          hiddenItems[i].removeAttribute('hidden');
        }
        moreBtn.style.display = 'none';
      }
      return;
    }

    // --- PC: L6トグルボタン（data-pc-l5-toggle） ---
    var pcL5Toggle = e.target.closest('[data-pc-l5-toggle]');
    if (pcL5Toggle) {
      e.preventDefault();
      var li = pcL5Toggle.closest('li');
      if (li) {
        var subsublist = li.querySelector('.vs-cat__card-subsublist');
        if (subsublist) {
          var isL5Open = !subsublist.hidden;
          subsublist.hidden = isL5Open;
          pcL5Toggle.textContent = isL5Open ? '＋' : '－';
        }
      }
      return;
    }

    // --- PC: L5トグルボタン（data-pc-toggle） ---
    var pcToggle = e.target.closest('[data-pc-toggle]');
    if (pcToggle) {
      e.preventDefault();
      var li = pcToggle.closest('li');
      if (li) {
        var sublist = li.querySelector('.vs-cat__card-sublist');
        if (sublist) {
          var isOpen = !sublist.hidden;
          sublist.hidden = isOpen;
          pcToggle.textContent = isOpen ? '＋' : '－';
        }
      }
      return;
    }

    // --- SP: アコーディオントグルボタン（data-toggle） ---
    var toggleTarget = e.target.closest('[data-toggle]');
    if (toggleTarget) {
      e.preventDefault();
      // L5サブサブアコーディオンのトグル（先にチェック）
      var subsubItem = toggleTarget.closest('.vs-cat__acc-subsub');
      if (subsubItem) {
        var subsubBody = subsubItem.querySelector('.vs-cat__acc-subsub-body');
        if (!subsubBody) return;
        var isSubsubOpen = !subsubBody.hidden;
        subsubBody.hidden = isSubsubOpen;
        toggleTarget.textContent = isSubsubOpen ? '＋' : '－';
        subsubItem.classList.toggle('vs-cat__acc-subsub--open', !isSubsubOpen);
        return;
      }
      // L4サブアコーディオンのトグル
      var subItem = toggleTarget.closest('.vs-cat__acc-sub');
      if (subItem) {
        var subBody = subItem.querySelector('.vs-cat__acc-sub-body');
        if (!subBody) return;
        var isSubOpen = !subBody.hidden;
        subBody.hidden = isSubOpen;
        toggleTarget.textContent = isSubOpen ? '＋' : '－';
        return;
      }
      // L3アコーディオンのトグル
      var accItem = toggleTarget.closest('.vs-cat__acc-item');
      if (!accItem) return;
      var body = accItem.querySelector('.vs-cat__acc-body');
      if (!body) return;
      var isAccOpen = !body.hidden;
      body.hidden = isAccOpen;
      toggleTarget.textContent = isAccOpen ? '＋' : '－';
      accItem.classList.toggle('vs-cat__acc-item--open', !isAccOpen);
      return;
    }

    var target = e.target.closest('[data-category]');
    if (!target) return;

    e.preventDefault();
    var categoryId = target.dataset.category;
    var params = Object.assign({}, lastSearchParams);

    if (categoryId) {
      params.category = categoryId;
    } else {
      delete params.category;
    }

    doSearch(params, 1);
  }

  // =========================================
  // 検索実行 & 結果描画
  // =========================================
  function doSearch(params, page) {
    lastSearchParams = params;
    currentPage = page;
    updateURL(params, page);

    hide(els.results);
    hide(els.empty);
    show(els.loading);

    fetchJSON(searchURL(params, page))
      .then(function (res) {
        hide(els.loading);
        if (res.total === 0) {
          if (lastSearchParams.keyword || lastSearchParams.category) {
            // キーワード/カテゴリ絞り込み中 → 結果エリアは表示したままグリッドに空メッセージ
            var emptyMsg = '該当する商品が見つかりませんでした。';
            if (lastSearchParams.keyword) {
              emptyMsg = '「' + escapeHTML(lastSearchParams.keyword) + '」に該当する商品が見つかりませんでした。';
            }
            emptyMsg += '<br>絞り込み条件を変更してお試しください。';
            els.grid.innerHTML = '<p class="vs-empty-inline">' + emptyMsg + '</p>';
            els.summary.textContent = '0件';
            if (lastSearchParams.keyword) show(els.keywordClear);
            renderPagination(1, 0);
            renderCategories(res.categories, res.total_all);
            show(els.results);
            els.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            show(els.empty);
          }
          return;
        }
        renderResults(res);
        show(els.results);
        els.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function (err) {
        hide(els.loading);
        show(els.empty);
        console.error('Vehicle search error:', err);
      });
  }

  function renderResults(res) {
    // サマリー
    var from = (res.page - 1) * res.per_page + 1;
    var to   = Math.min(res.page * res.per_page, res.total);
    var summaryText = res.total + '件中 ' + from + '〜' + to + '件を表示';
    if (lastSearchParams.keyword) {
      summaryText += '（「' + lastSearchParams.keyword + '」で絞り込み中）';
    }
    els.summary.textContent = summaryText;

    // キーワード入力欄のクリアボタン表示制御
    if (lastSearchParams.keyword) {
      show(els.keywordClear);
    } else {
      hide(els.keywordClear);
    }

    // 階層カテゴリ表示
    renderCategories(res.categories, res.total_all);

    // 商品グリッド
    var html = '';
    res.products.forEach(function (p) {
      var imgSrc = p.image_url
        ? p.image_url.replace(/(\.\w+)(\?.*)?$/, '_360x$1$2')
        : 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"><rect fill="%23f0f0f0" width="1" height="1"/></svg>');
      var priceHTML = formatPrice(p.price);
      var compareHTML = '';
      if (p.compare_at_price && parseFloat(p.compare_at_price) > parseFloat(p.price)) {
        compareHTML = '<span class="vs-card__compare">' + formatPrice(p.compare_at_price) + '</span>';
      }

      html += '<a href="' + escapeAttr(p.url) + '" class="vs-card">'
            + '<div class="vs-card__img-wrap">'
            + '<img src="' + escapeAttr(imgSrc) + '" alt="' + escapeAttr(p.title) + '" loading="lazy" width="360" height="360">'
            + '</div>'
            + '<div class="vs-card__info">'
            + '<p class="vs-card__vendor">' + escapeHTML(p.vendor) + '</p>'
            + '<p class="vs-card__title">' + escapeHTML(p.title) + '</p>'
            + '<p class="vs-card__price">' + compareHTML + priceHTML + '</p>'
            + '</div>'
            + '</a>';
    });
    els.grid.innerHTML = html;

    // ページネーション
    renderPagination(res.page, res.total_pages);
    updateMyBikeRegister();
  }

  function updateMyBikeRegister() {
    if (!els.myBikeRegister || !els.myBikeRegisterBtn) return;
    if (lastVehicleGid) {
      show(els.myBikeRegister);
      els.myBikeRegisterBtn.disabled = false;
    } else {
      hide(els.myBikeRegister);
    }
  }

  function setRegisterMessage(message, isError) {
    if (!els.myBikeRegisterMessage) return;
    els.myBikeRegisterMessage.textContent = message;
    els.myBikeRegisterMessage.classList.toggle('vs-my-bike-register__message--error', !!isError);
  }

  function myBikeAccountURL(vehicleGid) {
    var url = new URL(MY_BIKE_ACCOUNT_URL, window.location.origin);
    if (vehicleGid) url.searchParams.set('vehicle_gid', vehicleGid);
    url.searchParams.set('return_url', window.location.pathname + window.location.search);
    return url.toString();
  }

  function registerCurrentVehicle() {
    if (!lastVehicleGid) return;

    els.myBikeRegisterBtn.disabled = true;
    setRegisterMessage('Myバイクに登録します...', false);
    window.location.href = myBikeAccountURL(lastVehicleGid);
  }

  function renderPagination(page, totalPages) {
    if (totalPages <= 1) {
      els.pagination.innerHTML = '';
      hide(els.pagination);
      return;
    }

    var html = '';

    // 前へ
    if (page > 1) {
      html += '<button class="vs-page__btn" data-page="' + (page - 1) + '">&laquo; 前へ</button>';
    }

    // ページ番号
    var start = Math.max(1, page - 2);
    var end   = Math.min(totalPages, page + 2);
    if (start > 1) {
      html += '<button class="vs-page__btn" data-page="1">1</button>';
      if (start > 2) html += '<span class="vs-page__dots">…</span>';
    }
    for (var i = start; i <= end; i++) {
      html += '<button class="vs-page__btn' + (i === page ? ' vs-page__btn--active' : '') + '" data-page="' + i + '">' + i + '</button>';
    }
    if (end < totalPages) {
      if (end < totalPages - 1) html += '<span class="vs-page__dots">…</span>';
      html += '<button class="vs-page__btn" data-page="' + totalPages + '">' + totalPages + '</button>';
    }

    // 次へ
    if (page < totalPages) {
      html += '<button class="vs-page__btn" data-page="' + (page + 1) + '">次へ &raquo;</button>';
    }

    els.pagination.innerHTML = html;
    show(els.pagination);
  }

  function onPaginationClick(e) {
    var btn = e.target.closest('[data-page]');
    if (!btn) return;
    doSearch(lastSearchParams, parseInt(btn.dataset.page, 10));
  }

  // =========================================
  // URL 状態管理
  // =========================================
  function updateURL(params, page) {
    var qs = new URLSearchParams();
    if (params.q)            qs.set('vehicle', params.q);
    if (params.manufacturer) qs.set('manufacturer', params.manufacturer);
    if (params.displacement) qs.set('displacement', params.displacement);
    if (params.year)         qs.set('year', params.year);
    if (params.keyword)      qs.set('keyword', params.keyword);
    if (params.category)     qs.set('category', params.category);
    if (page > 1)            qs.set('page', page);
    var newURL = window.location.pathname + '?' + qs.toString();
    history.replaceState(null, '', newURL);
  }

  function loadFromURL() {
    var sp = new URLSearchParams(window.location.search);
    var vehicle      = sp.get('vehicle') || '';
    var manufacturer = sp.get('manufacturer') || '';
    var displacement = sp.get('displacement') || '';
    var year         = sp.get('year') || '';
    var keyword      = sp.get('keyword') || '';
    var category     = sp.get('category') || '';
    var page         = parseInt(sp.get('page') || '1', 10);

    if (vehicle || manufacturer) {
      var params = {};
      if (vehicle)      { params.q = vehicle; els.textInput.value = vehicle; }
      if (manufacturer) params.manufacturer = manufacturer;
      if (displacement) params.displacement = displacement;
      if (year)         params.year = year;
      if (keyword)      { params.keyword = keyword; els.keywordInput.value = keyword; }
      if (category)     params.category = category;
      doSearch(params, page);
    }
  }

  // =========================================
  // 初期化
  // =========================================
  function init() {
    // テキストサジェスト
    els.textInput.addEventListener('input', onTextInput);
    els.textInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); onTextSearch(); }
    });
    els.textBtn.addEventListener('click', onTextSearch);
    els.suggest.addEventListener('click', onSuggestClick);

    // サジェスト外クリックで閉じる
    document.addEventListener('click', function (e) {
      if (!els.suggest.contains(e.target) && e.target !== els.textInput) {
        hide(els.suggest);
      }
    });

    // 4段階カスケード
    els.mfr.addEventListener('change', onMfrChange);
    els.displacement.addEventListener('change', onDisplacementChange);
    els.model.addEventListener('change', onModelChange);
    els.year.addEventListener('change', onYearChange);
    els.dropdownBtn.addEventListener('click', onDropdownSearch);
    if (els.myBikeSelect) {
      els.myBikeSelect.addEventListener('change', onMyBikeSelectChange);
    }

    // キーワード絞り込み
    els.keywordBtn.addEventListener('click', onKeywordSearch);
    els.keywordInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); onKeywordSearch(); }
    });
    els.keywordClear.addEventListener('click', onKeywordClear);
    els.keywordInput.addEventListener('input', function () {
      if (els.keywordInput.value.trim()) {
        show(els.keywordClear);
      } else {
        hide(els.keywordClear);
      }
    });

    // カテゴリ絞り込み（イベント委任）
    els.collections.addEventListener('click', onCategoryClick);

    // ページネーション
    els.pagination.addEventListener('click', onPaginationClick);
    if (els.myBikeRegisterBtn) {
      els.myBikeRegisterBtn.addEventListener('click', registerCurrentVehicle);
    }

    // メーカー一覧読み込み
    loadManufacturers();

    // URL パラメータから復元
    loadFromURL();
  }

  // DOMReady
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
